"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserViewModel = void 0;
var class_transformer_1 = require("class-transformer");
var enums_1 = require("./enums");
var UserViewModel = /** @class */ (function () {
    function UserViewModel() {
        this.createdById = '';
        this.createdByUsername = '';
        this.createdDateTime = '';
        this.deactivatedDateTime = null;
        this.suspendedDateTime = null;
        this.locked = null;
        this.familyName = '';
        this.givenName = '';
        this.lakeId = '';
        this.lastLoginDateTime = '';
        this.lastModifiedById = '';
        this.lastModifiedByUsername = '';
        this.lastModifiedDateTime = '';
        this.locale = '';
        this.phoneNumber = '';
        this.primaryRegion = '';
        this.regions = [];
        this.tenantId = '';
        this.tenantUuid = '';
        this.username = '';
        this.userType = enums_1.UserTypeEnum.USER;
        this.userAccessPermissionType = enums_1.UserAccessBasedOnPermissionAndStateEnum.UNKNOWN;
        this.tenantName = '';
        this.tenantDateCreated = '';
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], UserViewModel.prototype, "createdById", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "createdByUsername", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "createdDateTime", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], UserViewModel.prototype, "deactivatedDateTime", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], UserViewModel.prototype, "suspendedDateTime", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], UserViewModel.prototype, "locked", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "familyName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "givenName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "lakeId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], UserViewModel.prototype, "lastLoginDateTime", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "lastModifiedById", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "lastModifiedByUsername", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "lastModifiedDateTime", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "locale", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "phoneNumber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "primaryRegion", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Array)
    ], UserViewModel.prototype, "regions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "tenantId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "tenantUuid", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "username", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "userType", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "userAccessPermissionType", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "tenantName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], UserViewModel.prototype, "tenantDateCreated", void 0);
    return UserViewModel;
}());
exports.UserViewModel = UserViewModel;
